<template>
  <b-col class="milestone-item px-0" style="flex: 0 0 20%">
    <p class="year h1" :style="{ color: milestone.color }">
      {{ milestone.year }}
    </p>
    <div class="arrow d-flex">
      <div v-if="milestone.year !== 1991" class="arrow-back"></div>
      <div
        class="arrow-body"
        :style="{ backgroundColor: milestone.color }"
      ></div>
      <div
        class="arrow-head"
        :style="{
          borderColor: `transparent transparent transparent ${milestone.color}`,
        }"
      ></div>
    </div>
    <div class="icons d-flex">
      <BgIcon
        v-for="(icon, i) in milestone.icons"
        :key="i"
        :icon="icon"
        :bgColor="milestone.color"
        :color="'#fff'"
      />
    </div>
    <ul class="desc" :style="{ color: milestone.color }">
      <li v-for="(desc, i) in milestone.desc" :key="i">{{ desc }}</li>
    </ul>
  </b-col>
</template>

<script>
import BgIcon from "@/components/BgIcon";

export default {
  props: ["milestone"],
  components: { BgIcon },
};
</script>

<style lang="scss">
.milestone-item {
  .year {
    margin-bottom: 10px;
    font-style: italic;
  }

  .arrow {
    height: 20px;
    margin-bottom: 10px;
    position: relative;

    &-back {
      position: absolute;
      left: 0;
      border-style: solid;
      border-width: 10px 0 10px 10px;
      border-color: transparent transparent transparent #fff;
    }

    &-body {
      flex: 1 0 auto;
    }

    &-head {
      border-style: solid;
      border-width: 10px 0 10px 10px;
      border-color: transparent transparent transparent #fff;
    }
  }

  .icons {
    margin-bottom: 10px;
  }

  .desc {
    padding-left: 20px;
    li {
      list-style: outside square;
    }
  }
}
</style>